import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { loadFields } from './store/fields/actions';
import { saveDeal } from 'bundles/apex/deals/form/store/deal/actions';

import FullForm from './layouts/full';
import LoadingSpinner from 'components/ui/loading_spinner';
import OverviewForm from './layouts/overview';
import layouts from './layouts';

export function DealForm({
  dealType,
  extraButton,
  fields,
  isDirty,
  layout,
  loadFields,
  saveDeal,
  stage,
  onCancel,
  onDirtyChange,
  onSave,
}) {
  React.useEffect(() => {
    if (!fields) {
      loadFields();
    }
  }, []);

  React.useEffect(() => {
    if (dealType && stage && fields && Object.values(fields).every(field => field.hidden)) {
      saveDeal(onSave);
    }
  }, [fields]);

  React.useEffect(() => {
    if (onDirtyChange) {
      onDirtyChange(isDirty);
    }
  }, [isDirty]);

  if (!fields) {
    return <LoadingSpinner/>;
  }

  let Component;
  if (layout === 'overview') {
    Component = OverviewForm;
  } else {
    Component = FullForm;
  }

  return <Component extraButton={extraButton} onCancel={onCancel} onSave={onSave} />;
}

DealForm.propTypes = {
  dealType: PropTypes.string,
  extraButton: PropTypes.node,
  fields: PropTypes.object,
  isDirty: PropTypes.bool,
  layout: PropTypes.oneOf(Object.values(layouts)),
  loadFields: PropTypes.func.isRequired,
  saveDeal: PropTypes.func,
  stage: PropTypes.string,
  onCancel: PropTypes.func,
  onDirtyChange: PropTypes.func,
  onSave: PropTypes.func,
};

const mapStateToProps = ({ fields, deal: { dealType, isDirty, stage } }) => ({
  dealType,
  fields,
  isDirty,
  stage,
});


const mapDispatchToProps = {
  loadFields,
  saveDeal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealForm);
